import { PDFDocument } from 'pdf-lib';
import { IMemberDetails } from '../state/model';
import { LogCannon } from '@ace-clublabs/log-cannon';
import { yearsBetweenDates, yearsSinceJoinYear } from './dateHelper';

export const onDownloadPDFCard = async (memberDetails: IMemberDetails) => {
  try {
    const clubCode = memberDetails.clubCode;
    const memberId =
      memberDetails.selectedCustomerId === '' ? memberDetails.loggedInCustomerId : memberDetails.selectedCustomerId;
    const member = memberDetails?.members?.find((m) => m.customerId === memberId);

    const fullName = member?.firstName + ' ' + member?.lastName;
    const memberNumber =
      member?.membershipCardNumber?.substring(0, 3) +
      '  ' +
      member?.membershipCardNumber?.substring(3, 6) +
      '  ' +
      member?.membershipCardNumber?.substring(6, 14) +
      '  ' +
      member?.membershipCardNumber?.substring(14, 16);

    const expDate = memberDetails.renewexpiredate;
    let level = '';
    switch (memberDetails.benefitLevels?.existingLevel.slice(0, 2)) {
      case 'PL':
        level = 'PLUS';
        break;
      case 'PR':
        level = 'PREMIER';
        break;
    }

    const years = yearsSinceJoinYear(memberDetails?.joinYear ?? '').toString();

    const url = 'tempcards/' + clubCode + '.pdf';

    const response = await fetch(url); // put the PDF in the "public" folder
    const arrayBuffer = await response.arrayBuffer();

    const pdfDoc = await PDFDocument.load(arrayBuffer);
    const form = pdfDoc.getForm();

    // YearsAsMember;
    // MemberNumber;
    // CardExpirationDate;
    // MemberName;
    // MemberOption;

    let nameField = form.getTextField('MemberName');
    nameField.setText(fullName);
    nameField = form.getTextField('YearsAsMember');
    nameField.setText(years);
    nameField = form.getTextField('MemberNumber');
    nameField.setText(memberNumber);
    nameField = form.getTextField('MemberOption');
    nameField.setText(level);
    nameField = form.getTextField('CardExpirationDate');
    nameField.setText(expDate);
    form.flatten();
    const modifiedBytes = await pdfDoc.save();

    const blob = new Blob([new Uint8Array(modifiedBytes)], { type: 'application/pdf' });
    const blobUrl = URL.createObjectURL(blob);

    return async () => {
      window.open(blobUrl, '_blank');
    };

    LogCannon.blast('PDF downloaded successfully');
  } catch (err) {
    console.error('Error reading PDF:', err);
    LogCannon.blast('PDF download error');
    return async () => {};
  }
};
